// Module
var code = "<div class=\"note-type-modal-launcher\" ng-if=\"vm.isNoteTypeEnabled\"> <a class=\"btn btn-sm launcher-button\" ng-click=\"vm.openNoteTypeModal()\"> <general-setting class=\"icon-setting\"></general-setting> </a> </div> ";
// Exports
module.exports = code;